// extracted by mini-css-extract-plugin
export default {"viewBox":"UserHelp_viewBox__No1V1"};